import { useEffect } from "react";
import styles from "./Header.module.css";

function Header() {
    useEffect(() => {
        function RolagemScroll() {
            const quadrado = document.getElementById("quadrado");
            const textoDente = document.getElementById("textoDente");

            if (window.scrollY > 10) {
                quadrado.classList.add(styles.quadradoFixo);
                textoDente.classList.add(styles.textoDenteInv);
            } else {
                quadrado.classList.remove(styles.quadradoFixo);
                textoDente.classList.remove(styles.textoDenteInv);
            }
        }

        window.addEventListener("scroll", RolagemScroll);
        return () => window.removeEventListener("scroll", RolagemScroll);
    }, []);

    return (
        <header className={styles.header}>
            <div id="quadrado" className={styles.quadrado}>
                <a href="https://semdorodonto.netlify.app/"><img src="/images/Header/tooth.webp" alt="Dente" /></a>
                <h2 id="textoDente">SEM DOR</h2>
            </div>
        </header>
    );
}

export default Header;
